<template>
  <div class="idea-checklist">
    <span class="label d-none d-lg-block">Recommendation checklist</span>

    <span class="label label--mobile d-lg-none" @click="mobileExpand"><b>Recommendation checklist:</b> {{completeLevel}}% completed</span>

    <div class="block d-none d-lg-block" v-if="type!=='view'">
<!--      <div class="expander">-->
<!--        <div class="expander-window">Pellentesque ornare sem lacinia quam venenatis vestibulum. Duis Pellentesque ornare sem lacinia quam venenatis vestibulum. Duis Pellentesque ornare sem lacinia quam venenatis vestibulum. Duis</div>-->
<!--        <button class="expander-button" @click="expand">Show more</button>-->
<!--      </div>-->
    </div>
    <div class="block d-none d-lg-block">
      <div class="chartcircle" :data-chart="completeLevel">
        <div class="chartcircle-wrapper">
          <div class="chartcircle-outer"></div>
          <div class="chartcircle-inner chartcircle-inner-left">
            <div class="chartcircle-inner-fill" v-if="process >= 180" :style="{opacity: 1, transform: `rotate(${process < 180 ? 0 : process - 180}deg)`}"></div>
          </div>
          <div class="chartcircle-inner chartcircle-inner-right">
            <div class="chartcircle-inner-fill" v-if="process" :style="{opacity: 1, transform: `rotate(${process > 180 ? 180 : process}deg)`}"></div>
          </div>
          <div class="chartcircle-number">{{completeLevel}}</div>
        </div>
        <span>{{completeLevel}}% completed</span>
      </div>
    </div>
    <div class="block block--checklist">
      <div class="checklist">
        <span :class="{checked: !!idea.headline}">Title</span>
        <span :class="{checked: !!idea.contentPost}">Description</span>
        <span :class="{checked: !!idea.idFile}">Cover photo</span>
        <span :class="{checked: !!idea.idCategory}">Category</span>
        <template v-if="idea._embedded">
           <span  v-for="field of contentFieldsForIdea" :key="field.idContentField" :class="{checked: field.value || field.idContentFieldOption}">
            {{ displayFieldName(field)}}
           </span>
        </template>
        <template v-if="idea.contentFields">
           <span  v-for="field of contentFields" :key="field.idContentField" :class="{checked: isFilled(field)}">
            {{ displayFieldName(field)}}
           </span>
        </template>
      </div>
    </div>

    <div class="progress d-lg-none">
      <div class="progress-fill" :style="{width: completeLevel +'%'}"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IdeaChecklist",
  props:['type', 'idea', 'typeChecklist'],
  computed: {
    completeLevel() {
      if(!this.idea) {
        return 0;
      }
      let counter = 0;
      let fieldNumbers = 3;
      if (this.idea.headline) {
        counter = counter +1;
      }
      if (this.idea.contentPost) {
        counter = counter +1;
      }
      if (this.idea.idFile) {
        counter = counter +1;
      }
      if(this.idea._embedded && this.idea._embedded.Content._embedded.ContentFieldValue) {
        this.contentFieldsForIdea.forEach(item => {
          fieldNumbers = fieldNumbers +1
          if (item.value || item.idContentFieldOption) {counter = counter +1;}
        })
      }
      if(this.typeChecklist) {
        this.contentFields.forEach(item => {
          fieldNumbers = fieldNumbers +1
          if(this.isFilled(item)) {counter = counter +1;}
        })
      }
      return (counter/fieldNumbers * 100).toFixed(0);
    },
    process() {
      return this.completeLevel/100 * 360;
    },
    contentFields() {
      return this.$store.getters.contentFieldsForIdeaBoard
    },
    contentFieldsForIdea() {
      if(this.idea._embedded.Content && this.idea._embedded.Content._embedded.ContentFieldValue) {
        return this.idea._embedded.Content._embedded.ContentFieldValue.filter(item => {
          return this.getFieldType(item) !== 'IMAGE'
        })
      }
      return []
    }
  },
  methods: {
    isFilled(field) {
      let value =this.idea.contentFields.find(elem => {
        return field.idContentField === elem.idContentField
      })
      return value && (value.value || value.values.length)
    },
    getFieldType(field) {
      let item = this.$store.getters.contentFieldsForIdeaBoard.find(elem => {
        return field.idContentField === elem.idContentField
      })
      return item.fieldType
    },
    displayFieldName(field) {
      let item = this.$store.getters.contentFieldsForIdeaBoard.find(elem => {
        return field.idContentField === elem.idContentField
      })
      return item.name
    },
    expand (e) {
      e.target.closest('.expander').classList.toggle('opened')
      var myText = e.target.closest('.expander').classList.contains('opened') ? 'Show less' : 'Show more'
      e.target.closest('.expander').querySelector('.expander-button').textContent = myText
    },
    mobileExpand (e) {
      e.target.closest('.idea-checklist').classList.toggle('opened')
    }
  }
}
</script>


{
from: {
  hour:
  minute:
}
time: 'from - to'